import { Icon } from "@msuite/ui/icons";
import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createMeta } from "@msuite/ui/table";
import { TransactionTypeTag } from "@msuite/ui/tag";
import { cn } from "@msuite/ui/utils";
import { createdAtFormatter } from "@msuite/utils/date";
import { formatNumber } from "@msuite/utils/numbers";
import type { TransactionListItem } from "@msuite/utils/types";

const columnHelper = createColumnHelper<TransactionListItem>();

export const columns = [
	columnHelper.accessor(createdAtFormatter, {
		id: "createdAt",
		header: localized("general_fields.created_at"),
		meta: createMeta({
			isTabular: true,
		}),
	}),
	columnHelper.accessor("operation", {
		id: "operation",
		header: localized("stock.operations.operation"),
	}),
	columnHelper.accessor("quantity", {
		id: "quantity",
		header: localized("general.quantity"),
		cell: (cell) => {
			const isAdd = cell.row.original.operation === "ADD";
			return (
				<div className={cn("h-stack justify-end", isAdd ? "text-emerald-600" : "text-red-600")}>
					<Icon name={isAdd ? "Plus" : "Minus"} />
					<span>{formatNumber(cell.getValue(), "integer").toString().padStart(8, " ")}</span>
				</div>
			);
		},
		meta: createMeta({
			isNumeric: true,
		}),
	}),
	columnHelper.accessor("userName", {
		header: localized("general_fields.created_by"),
		id: "createdBy",
	}),
	columnHelper.accessor("warehouseLocationName", {
		header: localized("stock.warehouse_location"),
		meta: createMeta({
			isTabular: true,
		}),
	}),
	columnHelper.accessor("type", {
		id: "type",
		cell: (cell) => <TransactionTypeTag type={cell.getValue()} />,
	}),
];
